import * as React from 'react';
import { useTranslation } from 'react-i18next';
import Moment from "moment";
import { DatesFieldFormRow } from '../../../common/controls/Relations/FormsControls';
import { IConfig } from './Models'
import { OptionType } from '../../../common/controls/ResourcesAutocompleteMI';
import { SubRowHeader } from '../../../common/controls/Relations/Components';

export interface IPersonProfileInsertData {

	personProfileId: string,
	personProfileName: string,

	selectedFrom: Moment.Moment,
	selectedTo: Moment.Moment,
	dateError: string,
}

interface IPersonProfileInsertControlProps {
	config: IConfig,

	value: IPersonProfileInsertData,
	onChange: (v: IPersonProfileInsertData) => void

	selectedEmployees: OptionType[],
}

export function PersonProfileInsertControl(props: IPersonProfileInsertControlProps) {
	const { t } = useTranslation();

	function handleChangeDate(val) {
		let copy = { ...props.value, ...val };
		props.onChange(copy);
	}
	
	return <div className="sub-input-row">
		<dl className="form-field">
			<dt>
				<label>{t("control.relation.personProfile")}:</label>
			</dt>
			<dd>
				<SubRowHeader>{props.value.personProfileName}</SubRowHeader>

				<DatesFieldFormRow
					from={props.value.selectedFrom}
					to={props.value.selectedTo}
					onChange={(from, to) => handleChangeDate({ selectedFrom: from, selectedTo: to })}
					errorText={props.value.dateError}
					dateFromConfig={props.config.fields.dateFrom}
					dateToConfig={props.config.fields.dateTo}
					editRow={false}
				/>
			</dd>
		</dl>
	</div>
}